import React from "react";
import { Routes, Route } from "react-router-dom";
import OidcCallback from "../components/OidcCallback";
import DataGridPage from "../pages/DataGridPage";

// OPTIMIZED: Lazy load the main page for faster initial load

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/Login/Callback" element={<OidcCallback />} />
      <Route path="*" element={<DataGridPage />} />
    </Routes>
  );
};

export default AppRoutes;
